import { useState, useEffect } from 'react';
import { Stack, Heading} from "@chakra-ui/react"
import { useLanguage } from "../components/LanguageContext";
import axios from 'axios';

const Dashboard = () => {
  const {language} = useLanguage()
  const isEnglish = language === "en";
  const [data, setData] = useState([]);

  // useEffect with an empty dependency array will run only once after the component mounts
  useEffect(() => {
    // call the function that makes a call to the backend for the data
    fetchData();
  }, []);

  // function to fetch Data
  const fetchData = async () => {
    try {
      const response = await axios.get('/api/transactions'); // cookies sent automatically
      console.log("Response data:", response.data);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching transaction data: ", error);
    }
  };
  
  let runningTotal = 0;

  return (
    <Stack spacing={5}
          p={8}
          w={{base: "100%", lg: "60%"}}
        >
          <Heading
              as="h1"
              size={{base: "lg", lg: "xl"}}
              fontWeight="bold"
              color="primary.800"
              textAlign="center"
            >
              {isEnglish ? "DASHBOARD" : "DASHBOARD"}
              
          </Heading>
    <div>
      {data.length === 0 ? (
      <div style={{ padding: "1rem", textAlign: "center", color: "gray" }}>
        {isEnglish ? "No data yet to display" : "No hay datos aún para mostrar"}
      </div>
    ) : (
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr
            style={{
              backgroundColor: "#00ADEF",
              color: "white",
              fontWeight: "bold",
            }}
          >
            <th style={{ padding: "10px", borderTopLeftRadius: "25px" }}>{isEnglish ? "Week" : "Semana"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Date" : "Fecha"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Payment" : "Pago"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Membership" : "Membresía"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Total Investment" : "Inversión Total"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Extra Payment" : "Pago Extra"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Balgod Match" : "Balgod Match"}</th>
            <th style={{ padding: "10px" }}>{isEnglish ? "Week Total" : "Total de la Semana"}</th>
            <th style={{ padding: "10px", borderTopRightRadius: "25px" }}>{isEnglish ? "Grand Total" : "Gran Total"}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((transaction, index) => {

            const rowTotal =
              Number(transaction.initialAmount) +
              Number(transaction.extraPayment) +
              Number(transaction.match);

              runningTotal += rowTotal;

              return (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "#ffffff" : "#D3D6FF",
                lineHeight: "2rem",
              }}
            >
              <td style={{ padding: "8px", textAlign: "center" }}>#{index+1}</td>
              <td style={{ padding: "8px", textAlign: "center" }}>{transaction.date}</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {(Number(transaction.initialAmount) + Number(transaction.fee)).toFixed(2)} dlls</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {transaction.fee} dlls</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {transaction.initialAmount} dlls</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {transaction.extraPayment} dlls</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {transaction.match} dlls</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {rowTotal.toFixed(2)} dlls</td>
              <td style={{ padding: "8px", textAlign: "center" }}>$ {runningTotal.toFixed(2)} dlls</td>
            </tr>
          );
        })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="8" style={{ textAlign: "right", padding: "10px", fontWeight: "bold" }}>
              Grand Total:
            </td>
            <td style={{ padding: "10px", fontWeight: "bold" }}>$ {runningTotal.toFixed(2)} dlls</td>
          </tr>
        </tfoot>
      </table>
    )}
      </div>
    </Stack>
  );
}

export default Dashboard;